import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetShutdownFilterValues } from '../model/actions';
import { fetchShutdownsThunk } from '../../../shared/model/actions';
import useResetDefaultFilter from '../../../shared/api/mutation/useResetDefaultFilter';
import { selectChosenFilterId } from '../model/selectors';

const ResetFilter = ({ render, ...props }) => {
  const dispatch = useDispatch();

  const { resetFilter } = useResetDefaultFilter();

  const chosenFilterId = useSelector(selectChosenFilterId);

  const reset = useCallback(async () => {
    await resetFilter(chosenFilterId);
    dispatch(resetShutdownFilterValues());
    await dispatch(fetchShutdownsThunk());
  }, [dispatch, chosenFilterId]);

  return render({ reset, ...props });
};

export default ResetFilter;
